module.exports = {
      id: "home_banner_en-usage",
      viewBox: "0 0 500 250",
      url: __webpack_public_path__ + "images/js_src_vue/page_listary_landing/sprite.d9b7df9a.svg#home_banner_en-usage",
      toString: function () {
        return this.url;
      }
    }